import * as React from 'react';
import * as PropTypes from 'prop-types';
import FillingForm from './FillingForm';
import { saveCheck, searchExistingCheck } from '../../../services/API/checks';
import { connect } from 'react-redux';
import './style.scss';
import SaveCheckModal from '../SaveCheckModal';

import errorMessages from '../../../../../constants/errorMessages';
import { Map } from 'immutable';
import { remotePaths } from 'router/routes';
import config from 'config';

@connect(
  () => {
    return {};
  },
  () => {
    return {
      goToCheckListPage: () => config.goToNewLK(remotePaths.checks),
    };
  },
)
export default class LoadingCashierCheck extends React.Component {
  static propTypes = {
    goToCheckListPage: PropTypes.func.isRequired,
  };

  state = {
    formData: { operationType: 'INCOME' },
    loadingDraft: false,
    loadingSave: false,
    showModal: false,
    responseData: null,
  };

  cancelSavingCheck = () => {
    this.setState({ showModal: false, confirmError: null });
  };

  goBack = () => {
    this.props.goToCheckListPage();
  };

  handleSubmitDraft = async (immutableData) => {
    this.setState({ formData: immutableData, loadingDraft: true });
    let data = immutableData.toJS();
    const response = await searchExistingCheck(data);
    if (response.isOk) {
      this.setState({
        draftError: null,
        responseData: response.data,
        showModal: true,
        loadingDraft: false,
      });
    } else {
      this.setState({
        draftError: response.error,
        responseData: null,
        showModal: true,
        loadingDraft: false,
      });
    }
  };
  handleConfirmData = async (immutableData) => {
    let data = immutableData.toJS();

    this.setState({ confirmLoading: true });
    if (data.receiptCategory) {
      data = {
        ...data,
        receiptCategory: { id: data.receiptCategory.value, title: data.receiptCategory.label },
      };
    }
    const response = await saveCheck(data);
    if (response.isOk) {
      this.setState({ confirmLoading: false });
      this.goBack();
    } else {
      this.setState({ confirmError: errorMessages.defaultServerError, confirmLoading: false });
    }
  };

  render() {
    const {
      formData,
      loadingDraft,
      showModal,
      draftError,
      responseData,
      confirmError,
      confirmLoading,
    } = this.state;
    return (
      <div className="white-block white-block__pad40">
        <h2 className="margin_bottom40">Введите реквизиты чека</h2>
        <FillingForm
          initialValues={formData}
          goBack={this.goBack}
          loading={loadingDraft}
          onSubmit={this.handleSubmitDraft}
        />
        {showModal && !draftError && (
          <SaveCheckModal
            initialValues={Map(responseData)}
            confirmError={confirmError}
            loading={confirmLoading}
            onSubmit={this.handleConfirmData}
            handleClose={this.cancelSavingCheck}
          />
        )}
      </div>
    );
  }
}
